import merge from 'lodash/merge';

const AWP_DEPLOY_ENV = VUE_APP_AWP_DEPLOY_ENV || 'development';
const DEV_ENV = VUE_APP_DEV_ENV;

function loadSpecConfig(env) {
  let specConfig;
  try {
    specConfig = require(`./${env}.json`);
  } catch (e) {
    if (env === 'default') {
      throw e;
    }
    specConfig = {};
  }

  return specConfig;
}

const defaultConfig = loadSpecConfig('default');
let specConfig = loadSpecConfig(AWP_DEPLOY_ENV);

if (AWP_DEPLOY_ENV === 'development' && DEV_ENV) {
  const devSpecConfig = require(`./${DEV_ENV}.json`);
  specConfig = merge(
    {},
    specConfig,
    devSpecConfig,
  );
}

const config = merge(
  {
    AWP_DEPLOY_ENV,
  },
  defaultConfig,
  specConfig,
);

export default Object.freeze(config);
